module.exports = __webpack_public_path__ + "img/flag_hanging_in_foyer.c3ac9af2.jpg";